module.exports = __webpack_public_path__ + "img/Halteplatz_für_Fahrzeuge_zum_Verletztentransport.3d65fc81.svg";